module.exports = __webpack_public_path__ + "static/media/logo-sm-kegstar-keg.a7276e94.svg";